import React from 'react'

import styled from '@emotion/styled'
import {
  AlignItems,
  Box,
  Color,
  Display,
  Heading1,
  JustifyContent,
  TextAlign,
  useTheme,
} from '@gousto-internal/citrus-react'

const HeadingContainer = styled(Box)`
  h1 {
    white-space: nowrap;

    @media (max-width: 886px) {
      white-space: normal;
    }
  }
`

export const RAFBoostHeader: React.FC = () => {
  const { theme } = useTheme()

  return (
    <HeadingContainer
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      paddingV={10}
    >
      <Heading1
        textAlign={TextAlign.Center}
        size={theme.tokens.typographyDefaults.display1.size}
        color={Color.White}
      >
        SHARE THIS LIMITED TIME OFFER
      </Heading1>
    </HeadingContainer>
  )
}
